import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { MdOutlineArrowLeft, MdEdit, MdDelete, MdBlock, MdOutlineLockOpen } from "react-icons/md";

import './css/view.css'

import { AppContext } from "../../Context";
import { Loader, GET, ClassToName, DateToText, FetchAsync } from "../../inc/Fetch"; 
import Header from "./Header";
import { Img } from '../../components/Elements';
import EditStudent from '../popups/EditStudent';

export default function GamesResults({action}) {

    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();

    const { userData, successData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;
    const [open, setopen] = successData;

    const [filter, setfilter] = useState({}); 
    const [data, setdata] = useState({}); 
    const [loading, setloading] = useState(true); 
    const [loader, setloader] = useState(false); 
    const [Open, setOpen] = useState(false); 

    async function loadData() {
        let r = await GET(`user/studentList?classes=${filter?.classes || ""}&text=${filter?.text || ""}`);
        
        setdata(r);
        setloading(false);
    }

    async function deleteUser(id) {

        if (!id) {
            return false;
        }
        
        let conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setloader(true);
        let r = await FetchAsync(`user/delete`, { _id: id });

        if (r?.error) {
            setopen({
                short:t("error",  { returnObjects: true })[r?.error],
                error:true
            });
        } else {
            loadData();
        }
        
        setloader(false);

    }

    async function blockUser(id, status) {

        if (!id) {
            return false;
        }

        let conf = window.confirm(t("error",  { returnObjects: true })[status ? 26 : 25]);
        if (!conf) {
            return false;
        }

        setloader(true);
        let r = await FetchAsync(`user/block`, { _id: id, status: status });

        if (r?.error) {
            setopen({
                short:t("error",  { returnObjects: true })[r?.error],
                error:true
            });
        } else {
            loadData();
        }
        
        setloader(false);
    }

    useEffect(() => {
        loadData();
    }, [filter?.classes, filter?.text]);

    if (loading) {
        return <Loader />
    }
    
    if (!data) {
        return false;
    }


    return (
        <>
            {loader && <Loader />}

            {Open && <EditStudent setOpen={setOpen} Open={Open} onSave={() => loadData()}/>}

            <div className='taskNewBody'>
                
                <Header />
                
                <div className='teacherTaskBox'>
                    
                    <div className='mainWidth shadow' style={{maxWidth:900}}>
        
                        <nav className='breadcrumbs'>
                            <Link to={`/`}>{t("home")}</Link>
                            <MdOutlineArrowLeft />
                            <Link>{t("header_user_menu_3")}</Link>
                        
                        </nav>
        
                        <div className='mainMyTasksTitleBox'>
                            <h1 className='mainTitle'>{t("header_user_menu_3")}</h1>
                        </div>

                        <div className='filterBox'>
                            <div>
                                {t("tasks_stats_2")} <b>({data?.students?.length})</b>
                            </div>
                            <form>
                                <input 
                                    className='searchInput' 
                                    type="search" 
                                    placeholder={`${t("search")}..`} 
                                    onChange={(d) => setfilter(p => ({
                                        ...p,
                                        text:d?.target?.value
                                    }))}
                                />
        
                                <select className='searchInput' style={{maxWidth:180}}
                                    onChange={(d) => setfilter(p => ({
                                        ...p,
                                        classes:d?.target?.value
                                    }))}
                                >
                                    <option value=''>- {t("classes")} -</option>
                                    {userinfo?.classes?.map((v, k) => {
                                        let cls = v?.split("-")[0];
                                        let grd = v?.split("-")[1];
                                        
                                        return (
                                            <option key={k} value={v}>{`${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`}</option>
                                        );
                                       
                                    })}
                                </select>
                            </form>
                        </div>
        
                        <div className='myTaskBody'>
                                    
                            <table className='table' style={{backgroundColor:"#fff"}}>
                                <thead>
                                    <tr>
                                        <td style={{width:80}}>{t("image")}</td>
                                        <td className='side'>{t("name")}</td>
                                        <td style={{width:120}}>{t("id")}</td>
                                        <td style={{width:100}}>{t("class")}</td>
                                        <td style={{width:90}}>{t("last_login")}</td>
                                        <td style={{width:130}}>{t("edit")}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.students?.map((v, k) => {

                                        return (
                                            <tr key={k}>
                                                <td ><Img src={`img/70x60/${v?.img}`} /></td>
                                                <td className='side'>{v?.name}</td>
                                                <td>{v?.zehot || "--"}</td>
                                                <td><span className='tag'><ClassToName  classes={v?.classes[0]}/></span></td>
                                                <td><DateToText time={v?.last_login} /></td>
                                                <td>
                                                    <a title={t("edit")} style={{display:"inline-table",}} onClick={() => setOpen(v?._id)}><button style={{margin:"auto", zoom:1.1}} className='btn green'><MdEdit /></button></a>
                                                    <a title={v?.status ? t("user_block") : t("user_unblock")} onClick={() => blockUser(v?._id, v?.status ? 0 : 1)} style={{display:"inline-table",}} ><button style={{margin:"auto", zoom:1.1}} className={`btn ${v?.status ? "gray" : "orange"}`}>{v?.status ? <MdBlock /> : <MdOutlineLockOpen />}</button></a>
                                                    <a title={t("delete")} style={{display:"inline-table",}} onClick={() => deleteUser(v?._id)} ><button type='button' style={{margin:"auto", zoom:1.1}} className='btn red'><MdDelete /></button></a>
                                                </td>
                                            </tr>

                                        );
                                    })}
                                </tbody>
                            </table>
        
                            {!data?.students?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}
                        </div>
        
                        
        
                    </div>
        
        
                </div>
        
               
            </div>
        </>
    )
}
